import { useState, useEffect } from "react";
const usePageTitle = () => {
	const [pageTitle, setPageTitle] = useState(document.title);

	useEffect(() => {
		const titleElement = document.querySelector("title");

		if (!titleElement) {
			console.warn("Elemento <title> no encontrado en el documento.");
			return;
		}

		const observer = new MutationObserver(() => {
			setPageTitle(document.title);
		});
		observer.observe(titleElement, { childList: true });
		return () => {
			observer.disconnect();
		};
	}, []);

	return { pageTitle };
};

export default usePageTitle;
